// extracted by mini-css-extract-plugin
export default {"overlay":"src-app-components-LoaderModal-style__ixGTN__overlay"};